// ============================================================================
// sql_db_view TS 配置示例（flag = example，§4.3 ⑤ / §4.4 ④）
// ----------------------------------------------------------------------------
// ★ 约定：
//   ① 文件路径 = `sql_db_view/configs/{group}/{flag}.ts`，default 导出签名
//      `(t, { model_app }) => config`（与 remotePages/configs 一致，model_app 恒为 'db_view'）；
//   ② **只做白名单字段的增量覆盖**（§4.4 ④），运行时 URL / 列（baseColumns）/
//      高级搜索字段（base_search_condition_config_list）一律不写 —— 它们来自
//      DbView / DbViewColumn（get_page_config 编译返回），DB 是单一真相源；
//   ③ 只支持高级搜索，无 searchConfig / 无增删改 URL / 无权限位（v20/v24）；
//   ④ flag 命中规则见 pageConfig.ts：`ts_config_map[view_flag]`（按文件名去 .ts 匹配）。
//     本示例文件名为 example —— 只有存在 flag=example 的 DbView 时才会生效，否则纯文档。
// ============================================================================
export default (t, { model_app }) => {
  void model_app; // 固定为 'db_view'，配置内不需要区分 app
  void t; // 需要多语言时用 t('...') 包按钮/标题文案；纯静态配置可不使用
  return {
    // ---- 页面标题相关（可选）----
    // title 由路由 meta 提供，一般不需要在这里配

    // ---- 视图形态（可选，均有后端默认值）----
    // enable_view_types: ['normal', 'pivot', 'pivot_charts'],  // 启用的视图类型
    // default_view_type: 'normal',                              // 默认视图
    // default_hide_view: false,                                 // 默认收起左侧保存视图面板
    // pivot_table_max_records: 10000,                           // 透视表最大记录数

    // ---- 头部按钮（可选；★ v24：不做权限校验，配置了就展示）----
    head_btn_list: [
      // 示例：一个「使用说明」按钮（button 组件形态与 remotePages 的 head_btn_list 相同）
      // {
      //   name: t('使用说明'),
      //   type: 'button',
      //   click: ({ dataSource }) => { console.log(dataSource); },
      // },
    ],

    // ---- 行按钮 / 行选择（可选）----
    // btn_list: [],
    // is_selection: false,
    // rowSelection: { type: 'checkbox', checkStrictly: false },

    // ---- 分页（可选）----
    // is_pagination: true,
    // pageSize: 50,
    // page_size_options: ['10', '20', '50', '100', '200', '500'],

    // ---- 单元格 / 行渲染（可选）----
    // customCell: ({ record, column }) => { ... },
    // customRow: (record, index) => { ... },
    // customHeaderCell: (column) => { ... },

    // ---- 高级搜索（可选；字段本体来自 DbViewColumn.is_base_query / is_default_query）----
    // 默认条件组：打开页面时预置的搜索条件（结构与 lybase 高级搜索一致）
    default_search_condition_config_list: [
      // [
      //   {
      //     field_name: 'is_active',
      //     operator: 'eq',
      //     value: [true],
      //     format: 'input',
      //     class_name: 'bool',
      //   },
      // ],
    ],
    // 条件分组列表（搜索字段分组展示）
    condition_group_config_list: [],
    // 隐藏查询条件：始终附加、用户不可见（后端 build_where 会一并推进 WHERE）
    advanced_base_conditions: [],

    // ---- 其它（可选）----
    // required_condition: [],        // 全局切换配置
    // refresh_type: '手动',           // '手动' | '5s' | '10s' | '30s'
    // detailConfigs: {},             // 详情抽屉配置（key → { component, width, title }）
    // i18n: null,                    // 多语言覆盖配置
    // default_column_field: [],      // 默认展示列
  };
};
